import { useParams } from 'react-router-dom';

const useSessionId = () => {
  const { sessionId } = useParams<{ sessionId: string }>();

  return parseInt(sessionId);
};

export default useSessionId;
